import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ButtonBase from "@material-ui/core/ButtonBase/ButtonBase";

import infoIcon from "../../assets/info.png";


// class definition
export class InfoIcon extends PureComponent {

    static propTypes = {
        style: PropTypes.any,
        onPress: PropTypes.func,
    };

    static defaultProps = {
        style: [],
        onPress: () => undefined,
    };

    render() {

        // resolve input
        const { style, onPress } = this.props;

        // render view
        return (
            <ButtonBase style={{...style, paddingTop: 15, paddingRight: 15}} onClick={onPress}>
                <img style={styles.infoIcon} src={infoIcon} />
            </ButtonBase>
        );
    }
}


const styles = {
    infoIcon: {
        width: 26,
        height: 26
    },
    info: {
        color: "#9b9b9b",
        marginLeft: 9,
    },
    infoText: {
        fontSize: 12
    }
};



// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/InfoIcon.js